import type { CopyRenderer, CopySegment } from './types'

/**
 * Akses Premium copy.
 *
 * One audience only. A child hits the premium wall mid-book and asks the adults responsible for
 * them to open it; those adults get the card, the child gets a toast. There is deliberately no
 * ACTOR renderer — the event is a roll-up shared by every child in the same audience, so an actor
 * row on it would show one child a card about another.
 */

const UNKNOWN_STUDENT = 'Seorang siswa'

/**
 * "{Siswa} memohon diberikan akses premium."
 * "{Siswa} dan {n} lainnya memohon diberikan akses premium."
 *
 * Counts `subjectCount` — the children folded into this group by `emitRollup` — not
 * `recipientCount`, which is how many adults were told. `studentName` is frozen at the first
 * request in the bucket, so the sentence keeps naming whoever asked first however large the group
 * grows; that is the same choice `renderShareActorCopy` makes with `recipientName`.
 */
export const renderPremiumAccessRequestedRecipientCopy: CopyRenderer = (view) => {
  const studentName = view.snapshot.studentName ?? UNKNOWN_STUDENT
  // `subjectCount` is 0 on nothing this producer writes, but a hand-seeded or pre-roll-up row
  // would otherwise render "dan -1 lainnya".
  const others = Math.max(0, view.subjectCount - 1)

  const body: CopySegment[] = [{ text: studentName, bold: true }]

  if (others > 0) {
    body.push({ text: ' dan ' }, { text: `${others} lainnya`, bold: true })
  }

  body.push({ text: ' memohon diberikan akses premium.' })

  return { body }
}
